// @flow
import Register from './Register';
import container from './container';

export default container(Register);
